module.exports = __webpack_public_path__ + "img/3-itol-tree-link.d23b4e66.png";